exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".avs-hint[data-v-15b924d5]{font-size:14px;line-height:22px;color:#333;margin:8px 0}.avs-hint--desc[data-v-15b924d5]{color:#606266}.avs-switch-row[data-v-15b924d5]{display:flex;align-items:center;gap:12px;margin:16px 0 8px}.avs-switch-label[data-v-15b924d5]{font-size:14px;color:#333}.avs-version-section[data-v-15b924d5]{margin-top:8px}.avs-version-list[data-v-15b924d5]{max-height:400px;overflow-y:auto;border-top:1px dashed #ebeef5;padding-top:28px}.avs-version-item[data-v-15b924d5]{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-15b924d5&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/AdVersionShield.vue
// module id = 451
// module chunks = 0